import styles from "./MobMenu.module.scss";
import Link from "next/link";
import { MenuBuilder } from "../../../BuilderIO/Menu/Menu.builder";
import Srcset from "@/components/common/Srcset";
import { useDispatch, useSelector } from "react-redux";
import { handleSignOut, mobMenuHeigh, slideToggle } from "@/helpers/userHelpers";
import { deleteCookie } from "cookies-next";
import { useIsPreviewing } from "@builder.io/react";
import { useEffect, useState } from "react";
import { generalConstants } from "@/utils/constants";
import { passMsgToAccountSidebar } from "@/redux/actions/loggedInUser";
import { isGuest } from "@/redux/actions/pwaAction";
import Search from "../../Search";
import { isMenuVisible, isPwaShowShopMenu, isSubmenuVisible, setSearchIcon } from "@/redux/actions/headerAction";
import { setGlobalActiveTab } from "@/redux/actions/generalAction";
import { setScrollPos } from "@/redux/actions/drawerAction";

export default function HeaderComp(props) {
  const isPreviewing = useIsPreviewing();
  let [showPwaBack, setShowPwaBack] = useState(false);
  const dispatch=useDispatch();
  const pwaSubMenuVisible=useSelector(
    (state) => state.header.isPwaSubmenuVisible
  );
  useEffect(() => {
    if(pwaSubMenuVisible){
      setShowPwaBack(true)
    } else {
      setShowPwaBack(false)
    }
    }, [pwaSubMenuVisible]);
  let logUser = useSelector((state) => state.loginUser);
  let firstName = "";
  let loggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  if (logUser && logUser.userData && logUser.userData.firstName) {
    firstName = logUser.userData.firstName;
  } else {
    firstName = "";
  }
  let { setMobileAccountBar, setNavSidebarOpen } = props;
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  // check if search icon is already clicked
  const isSearchIcon = useSelector((state) => state.header.setIconSearch);
  // const { selectedIcon, selectIcon } = props;

  useEffect(() => {

    mobMenuHeigh();
    const mobMenu = document.querySelector(".mob_menus");
    const pwaTransition = document.querySelector(".pwa-transition");
    const closeBlock = document.querySelector(".pwa_mob_wrapper .close_block");
    if(mobMenu && isPWA){
      if(pwaTransition){
        mobMenu.style.display = "none";
        closeBlock.style.display = "none";
      } else {
        mobMenu.style.display = "block";
        closeBlock.style.display = "block";
      }
    }
  })

  return (
    <section className={`mob_menus ${styles.mob_menus}`}>  
      <div className={`${styles.mob_top_menus} ${isPWA && styles.pwa_mob_top_menus}`}>{props.topLinks}</div>
      {/* if pwa then display search bar inside menu side bar */}
      
      {isPWA &&<div className={styles.pwa_search_wrapper}>
      {showPwaBack && <a
          
          onClick={() => {
            dispatch(isPwaShowShopMenu(true))
          }}
        >
          <Srcset
            requirePath={true}
            svgFile={true}
            className={styles.pwa_menu_back_icon}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
          />
        </a>}
        <div
          className={`desktop_header_icon search-icon-mobile mob_search_ele ${props.searchStyle.search_icon}
          ${props.searchStyle.icons_wrapper_li} ${
            isSearchIcon
            ? `selected ${props.searchStyle.selected}`
            : ""
            }
          `}
          onClick={(e) => {
            props.handleSearchClick();
            // is search icon is already clicked then clicking again will set to false.
            !isSearchIcon ? dispatch(setSearchIcon(true)): dispatch(setSearchIcon(false))
          }}
        >
          <Search isSuperbrandHeroPresent={props.isSuperbrandHeroPresent && !props.isScroll} isPWA={isPWA} />
          <span className="x-small opacity-50">Search</span>
        </div>
      </div>}
      <div className={`${styles.mob_main_menus}`}>
        <MenuBuilder />
        {/* if pwa then hide the bottom menu */}
        {((loggedIn || isPreviewing ) && !isPWA) ? (
          <div
            className={`${styles.mob_bottom_menus} ${styles.account_detail_wrap} mob_bottom_menus_mobile`}
          >
            <div
              className={`${styles.heading}`}
              onClick={(e) => {
                let target = e.currentTarget;
                let parent = target.parentElement;
                parent.classList.toggle(`${styles.open}`);
                slideToggle(target.nextElementSibling);
                mobMenuHeigh()
              }}
            >
              <div className={`${styles.plus_button}`}>
                <h5 className={`normal-sm normal-xs italic`}>Hello</h5>
                <h3 className="large-sm large-xs light">{firstName ? firstName.replace('N/A','') : ''}</h3>
                <Srcset
                  height="15.86"
                  width="20"
                  alt="User"
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Plus/large.svg"}
                />
              </div>
            </div>
            <ul className="account_detail_content" style={{ display: "none" }}>
              <li>
                <Link href="/account"
                    className="small-sm small-xs account-tablet-cta"
                    onClick={() => setNavSidebarOpen(false)}
                  >
                    <span className={`${styles.sign_in}`}>
                      <Srcset
                        height="15.86"
                        width="20"
                        alt="User"
                        requirePath={true}
                        svgFile={true}
                        src={"images/Icons/User-Signed-In 2.svg"}
                      />
                    </span>
                    My account
                </Link>
                <a
                  className="small-sm small-xs mobile-account-cta ga_header_account"
                  
                  onClick={() => {
                    setMobileAccountBar(true);
                  }}
                >
                  <span className={`${styles.sign_in}`}>
                    <Srcset
                      height="15.86"
                      width="20"
                      alt="User"
                      requirePath={true}
                      svgFile={true}
                      src={"images/Icons/User-Signed-In 2.svg"}
                    />
                  </span>
                  My account
                  <span className={`${styles.account_arrow}`}>
                    <Srcset
                      height="10"
                      width="12"
                      alt="arrow"
                      requirePath={true}
                      svgFile={true}
                      src={"images/Icons/Arrow/Right/large.svg"}
                    />
                  </span>
                </a>
              </li>
              <li>
                <a href="/faq" onClick={() => setNavSidebarOpen(false)} className="small-sm small-xs">Help</a>
              </li>
              <li>
                <a onClick={()=>handleSignOut()} className="small" >
                  Sign out
                </a>
              </li>
            </ul>
          </div>
        ) : (
          // if PWA then hide the bottom menu(if userlogged in)
          !isPWA && <div className={`${styles.mob_bottom_menus} mob_bottom_menus_mobile`}>
            <ul>
              <li>
                <Link href="/account"
                    className="small account-tablet-cta"
                    onClick={() => setNavSidebarOpen(false)}
                  >
                    <span className={`${styles.sign_in}`}>
                      <Srcset
                        svgFile={true}
                        src={"images/Icons/User.svg"}
                        requirePath={true}
                        height="30"
                        width="20"
                        alt="User"
                      />
                    </span>
                    Sign in | Register
                </Link>
                <a
                  className="small-sm small-xs mobile-account-cta ga_header_account"
                  
                  onClick={() => {
                    setMobileAccountBar(true);
                    dispatch(isGuest(false))
                    // dispatch(passMsgToAccountSidebar(""))
                  }}
                >
                  <span className={`${styles.sign_in}`}>
                    <Srcset
                      svgFile={true}
                      src={"images/Icons/User.svg"}
                      requirePath={true}
                      height="30"
                      width="20"
                      alt="User"
                    />
                  </span>
                  Sign in | Register
                </a>
              </li>
              <li>
                <a href="/faq" onClick={() => setNavSidebarOpen(false)} className="small-sm small-xs">Help</a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}
